import { getLinkHref } from 'shared/helpers/uri';
import { FormattedProps } from './types';
import { EngagementUnit } from '../../shared/types';
import { BlockOneshopUnauthenticatedRenewal } from 'shared/api/client';
import { Link, TitleHtmlTag } from 'shared/types';

export default function propsFormatter(
  content: BlockOneshopUnauthenticatedRenewal['content']
): FormattedProps {
  const minorProductsEngagementUnit: Record<string, EngagementUnit> = {};

  content.minorProducts.forEach(minor => {
    if (minor.productId && minor.engagementUnit) {
      minorProductsEngagementUnit[minor.productId] =
        EngagementUnit[minor.engagementUnit];
    }
  });

  return {
    title: {
      label: content.title.label ?? '',
      htmlTag: content.title.htmlTag
        ? (content.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    saleDeviceId: content.saleDeviceId,
    api: {
      getRenewalOffer: {
        url: content.apis?.crm_management_acts_qrcode?.url ?? '',
        method: content.apis?.crm_management_acts_qrcode?.method || 'GET'
      }
    },
    productPriceLabel: content.productPriceLabel ?? undefined,
    productOffer: content.products.map(product => ({
      productId: product.productId,
      engagementUnit: product.engagementUnit
        ? EngagementUnit[product.engagementUnit]
        : null,
      groups: product.groups?.map(group => ({
        title: group.title || '',
        isMoreChannels: group.isMoreChannels,
        displayChevron: group.display_chevron,
        hasDescriptionsIcon: group.descriptions.some(
          description => description.icon?.link
        ),
        descriptions: group.descriptions.map(description => ({
          icon: getLinkHref(
            description.icon?.link ? (description.icon.link as Link) : null
          ),
          content: description.content
        })),
        channels: group.channels.map(channel => ({
          label: channel.channel.media?.description ?? null,
          href: getLinkHref(
            channel.channel.media?.link
              ? (channel.channel.media.link as Link)
              : null
          )
        }))
      })),
      moreChannelsIcon: {
        label: product.moreChannelsIcon?.description ?? null,
        href: product.moreChannelsIcon?.link.href ?? ''
      }
    })),
    minorProductsTitle: {
      label: content.minorProductsTitle.label ?? '',
      htmlTag: content.minorProductsTitle.htmlTag
        ? (content.minorProductsTitle.htmlTag as TitleHtmlTag)
        : undefined
    },
    minorProductsEngagementUnit,
    firstAlertBox: {
      status: content.firstAlertBox.status,
      title: content.firstAlertBox.title,
      content: content.firstAlertBox.content,
      link: content.firstAlertBox.cta?.link
        ? {
            label: content.firstAlertBox.cta?.label ?? '',
            href: getLinkHref(content.firstAlertBox.cta.link as Link)
          }
        : null
    },
    secondAlertBox: {
      status: content.secondAlertBox.status,
      title: content.secondAlertBox.title,
      content: content.secondAlertBox.content,
      link: content.secondAlertBox.cta?.link
        ? {
            label: content.secondAlertBox.cta?.label ?? '',
            href: getLinkHref(content.secondAlertBox.cta.link as Link)
          }
        : null
    },
    phoneLabel: content.phoneNumberLabel,
    mobileOperatorTitle: {
      label: content.mobileOperatorTitle.label ?? '',
      htmlTag: content.mobileOperatorTitle.htmlTag
        ? (content.mobileOperatorTitle.htmlTag as TitleHtmlTag)
        : undefined
    },
    submitButton: {
      label: content.submitButton.label ?? '',
      link: getLinkHref(
        content.submitButton.link ? (content.submitButton.link as Link) : null
      )
    }
  };
}
